module.exports = __webpack_public_path__ + "static/media/py.1a604331.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/py.svg
// module id = 1337
// module chunks = 0